import React from 'react'
import api from '../../API/api'


const StudentView = (props) => {



    const approveStudent = () => {
        api.approveStudent(props?.modalData).then((res) => {
            // console.log(res);
            props.handleClose()
            props.refreshData()
        })
            .catch((err) => {
                // console.log(err.response);
            })
    }
    const approveAlumni = () => {
        api.approveAlumni(props?.modalData).then((res) => {
            // console.log(res);
            props.handleClose()
            props.refreshData()
        })
            .catch((err) => {
                // console.log(err.response);
            })
    }



    return (
        <>
            {props.modalData &&
                <>
                    <div className={`row p-4 border ${props?.modalData.isApprove ? 'border-success' : 'border-danger'} `}>
                        <div className="col-md-6 form-group p-2">
                            {/* <label for="">Student Name</label>
                <h6> <strong> {props?.modalData.name}</strong></h6> */}

                            <div className='my-3'>
                                Name : <strong> {props?.modalData.name}</strong>
                            </div>


                            <div className='my-3'>
                                Registration: <strong> {props?.modalData.registration}</strong>
                            </div>

                            <div className='my-3'>
                                Roll No : <strong> {props?.modalData.enrollment}</strong>
                            </div>

                            <div className='my-3'>
                                School: <strong> {props?.modalData.school}</strong>
                            </div>

                            <div className='my-3'>
                                Course <strong>{props?.modalData.course}</strong>
                            </div>
                            <div className='my-3'>
                                Date Of Birth <strong>{props?.modalData.dob}</strong>
                            </div>



                        </div>

                        <div className="col-md-6 form-group p-2">
                            <div className='my-3'>
                                Admission Year: <strong>{props?.modalData.admissionYear}</strong>
                            </div>
                            <div className='my-3'>
                                Batch: <strong>{props?.modalData.batch}</strong>
                            </div>
                            <div className='my-3'>
                                Address: <strong>{props?.modalData.address}</strong>
                            </div>
                            <div className='my-3'>
                                Email: <strong>{props?.modalData.email}</strong>
                            </div>
                            <div className='my-3'>
                                Phone: <strong>{props?.modalData.phone}</strong>
                            </div>
                            <div className='my-3'>
                                Caste: <strong>{props?.modalData.caste}</strong>
                            </div>
                        </div>



                        <div>
                            <hr/>
                            <div className='my-3'>
                                Alumni Speak: <strong>{props?.modalData.shortNote}</strong>
                            </div>
                        </div>


                    </div>

                    <div className='text-center mt-3'>

                        {props.type === 'alumni' ?
                            <>
                                <button className='btn btn-success' onClick={() => approveAlumni()}>Approve Alumni</button>
                            </> :
                            <>
                                {!props?.modalData.isApprove &&
                                    <button className='btn btn-success' onClick={() => approveStudent()}>Approve</button>
                                }
                            </>
                        }
                    </div>
                </>
            }
        </>
    )
}

export default StudentView;